import Vue from 'vue'
import { Slide } from 'vue-carousel'

import Responsive from '../../components/core/Responsive'
import HomeSearchWidgetDesktop from '../../components/Search/HomeSearchWidgetDesktop'
import HomeSearchWidgetMobile from '../../components/Search/HomeSearchWidgetMobile'
import DestinationSEOLinkMobile from '../../components/Home/DestinationSEOLinkMobile'
import FeaturedReview from '../../components/FeaturedReview'
import Rating from '../../components/core/Rating'
import CurrencyContext from '../../components/core/CurrencyContext'

const Carousel = require('../../components/core/Carousel').default
Vue.component('home-search-widget-desktop', HomeSearchWidgetDesktop)
Vue.component('home-search-widget-mobile', HomeSearchWidgetMobile)
Vue.component('responsive', Responsive)
Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)
Vue.component('destination-seo-link-mobile', DestinationSEOLinkMobile)
Vue.component('rating', Rating)
Vue.component('featured-review', FeaturedReview)
Vue.component('currency-context', CurrencyContext)

const apps = document.querySelectorAll('.vue-app');

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))

document.addEventListener('DOMContentLoaded', () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const search = urlSearchParams.get('search')
  if (search === 'resort') {
    $('.search-input-trigger').trigger('click')
    $('.search-toggle-resort').trigger('click')
  }
  else if (search === 'liveaboard') {
    $('.search-input-trigger').trigger('click')
    $('.search-toggle-liveaboard').trigger('click')
  }
  else if (search === 'ecoventure') {
    $('.search-input-trigger').trigger('click')
    $('.search-toggle-ecoventure').trigger('click')
  }
})